var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationScheduleDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "information-dark-icon.e4c0d26e2e7444ad3e0d41e4c9d1eb6e",
    d: "M62,56a6,6,0,1,0,6,6,6,6,0,0,0-6-6Zm0,2.46a.78.78,0,1,1-.78.78A.78.78,0,0,1,62,58.46Zm1.44,6.78H60.8a.48.48,0,0,1,0-.96h.84V61.64h-.48a.48.48,0,0,1,0-.96h.96a.48.48,0,0,1,.48.48v3.12h.84a.48.48,0,0,1,0,.96Z",
    transform: "translate(-56 -56)",
    fill: "#6d7077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationScheduleDarkIcon);
export default __webpack_public_path__ + "static/media/information-schedule-dark-icon.8220414394a166666c8ab5f34d86e8fa.svg";
export { ForwardRef as ReactComponent };